import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AdminContext, UserContext } from '../../../App';
import './Navbar.css'

const Navbar = () => {
  const [isAdmin, setIsAdmin] = useContext(AdminContext)
  const [loggedInUser, setLoggedInUser] = useContext(UserContext)
  useEffect(() => {
      fetch('https://assignment-11-samiun.herokuapp.com/isAdmin?email=' + loggedInUser.email)
      .then(res => res.json())
      .then(data => (data.length > 0) && setIsAdmin(true))
  }, [loggedInUser.email]) 
    return (
<nav className="navbar navbar-expand-lg navbar-light container bg-transparent">
  <div className="container-fluid">
    <img src={require('../../../images/logo.png').default} alt=""/>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav ms-auto me-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <Link className="nav-link active" aria-current="page" to="/">Home</Link>
        </li>
        <li className="nav-item">
          <a className="nav-link ms-3" href="#projects">Projects</a>
        </li>
        <li className="nav-item">
          <a className="nav-link ms-3" href="#blog">Blog</a>
        </li>
        <li className="nav-item">
          <a className="nav-link ms-3" href="#contact">Contact</a>
        </li>
        <li className="nav-item">
          {isAdmin ? <Link className="nav-link ms-3" to="/orderlistadmin">Admin</Link> : <Link className="nav-link ms-3" to="/order">Dashboard</Link>}
        </li>
        <li className="nav-item">
          <a className="nav-link ms-3" href="#faq">FAQ</a>
        </li>
        <li className="nav-item">
          <Link to="/login" style={{textDecoration: 'none'}}><button className="nav-link btn-style" href="#" style={{marginLeft: '50px'}}>Login</button></Link>
        </li>
      </ul>
    </div>
  </div>
</nav>
    );
};

export default Navbar;